import { UsuarioPerfil } from '../types/enums/UsuarioPerfil';

export const verificarThinkWayAdmin = (userRole: UsuarioPerfil): boolean => {
    return userRole === UsuarioPerfil.THINKWAY_ADMIN;
};

export const verificarOwner = (userRole: UsuarioPerfil): boolean => {
    return userRole === UsuarioPerfil.OWNER;
};

export const verificarAcessoAdministrador = (userRole: UsuarioPerfil): boolean => {
  return userRole === UsuarioPerfil.THINKWAY_ADMIN || 
         userRole === UsuarioPerfil.EMPRESA_ADMIN || 
         userRole === UsuarioPerfil.OWNER;
};

export const verificarAcessoTotal = (userRole: UsuarioPerfil): boolean => {
  // Owners e ThinkWay Admins têm acesso total sem restrições
  return userRole === UsuarioPerfil.THINKWAY_ADMIN || userRole === UsuarioPerfil.OWNER;
};

export const isAdminOrOwner = (userRole: UsuarioPerfil): boolean => {
  // Função auxiliar para verificar se é admin ou owner (acesso total)
  return verificarAcessoTotal(userRole) || userRole === UsuarioPerfil.EMPRESA_ADMIN;
};

export const verificarAcessoConfiguracoesSistema = (userRole: UsuarioPerfil): boolean => {
  // Apenas ThinkWay Admin e Owner podem acessar as configurações do sistema (perfis de acesso)
  return userRole === UsuarioPerfil.THINKWAY_ADMIN || userRole === UsuarioPerfil.OWNER;
};